import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23 22.9948C10.4184 22.7322 0.267862 12.5816 0.00524902 0H15C19.4183 0 23 3.58172 23 8V22.9948Z",
      fill: "#F55953"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.6922 7.6449C18.0828 7.25438 18.0828 6.62121 17.6922 6.23069C17.3017 5.84016 16.6685 5.84016 16.278 6.23069L13.4615 9.04716L10.6451 6.23069C10.2546 5.84016 9.62139 5.84016 9.23086 6.23069C8.84034 6.62121 8.84034 7.25438 9.23086 7.6449L12.0473 10.4614L9.2307 13.278C8.84018 13.6685 8.84018 14.3017 9.2307 14.6922C9.62123 15.0827 10.2544 15.0827 10.6449 14.6922L13.4615 11.8756L16.2782 14.6922C16.6687 15.0827 17.3019 15.0827 17.6924 14.6922C18.0829 14.3017 18.0829 13.6685 17.6924 13.278L14.8758 10.4614L17.6922 7.6449Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }